import NoData from './NoData'

export { NoData }